export default __webpack_public_path__ + "static/media/perfil.9b0d3dce.png";